import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { languageOptions } from '@/module/Nomen/Language/model/LanguageModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type LanguageSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function LanguageSelectControl<T extends FieldValues>(props: LanguageSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(languageOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
